import { gql } from '__generated__';

export default gql(`
  mutation EditParticipantBackend($input: EditParticipantInput!) {
    editParticipant(input: $input) {
      id
      first_name
      last_name
      email
    }
  }
`);
